enum RenderingCTATrackingIDs {
  RENDERING_CTA = 'rendering-cta',
  LEARN_MORE = 'learn-more',
  RENDERING_MODULE_CTA = 'rendering-module-cta',
  MODULE_BUTTON = 'module-button',
  VISIT_WEBSITE = 'visit-website',
}

export { RenderingCTATrackingIDs };
